window.axios.interceptors.response.use(function (response) {
    return response;
}, function (error) {
    let message;
    if(error && error.response) {
        switch (error && error.response.status) {
            case 400:
                message = error.response.data.error;
                Swal.fire({
                    icon: 'error',
                    title: 'Неверные данные!',
                    html: message,
                });
                break;
            case 401:
                message = error.response.data.error;
                Swal.fire({
                    icon: 'error',
                    title: 'Ошибка.',
                    html: message,
                });
                break;
            case 422:
                message = error.response.data.error;
                Swal.fire({
                    icon: 'error',
                    title: 'Внимание!',
                    html: message,
                });
                break;
            case 500:
                if(error.response.data.error) message = error.response.data.error;
                else message = 'Произошла ошибка. <br> Вы можете написать нам на почту order@myrental.by <br> или позвонить по телефону +7 977 409 72 39';
                Swal.fire({
                    icon: 'error',
                    title: 'Упс...',
                    html: message,
                });
                break;
            case 404:
                // window.location.href = '/404';
                break;
            default:
                return Promise.reject(error);
        }
    }

});
